import VueInstance from 'vue'

export default {
  install (Vue, params) {
    Vue.prototype.$bus = new VueInstance()
  }
}
